import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_NOTIFICATION_TYPES = '[VeranstaltungenModul] GetNotificationTypes laden';
export const GET_NOTIFICATION_TYPES_AUSFUEHREN = '[VeranstaltungenModul] GetNotificationTypes ausführen';
export const GET_NOTIFICATION_TYPES_ERFOLGREICH = '[VeranstaltungenModul] GetNotificationTypes laden erfolgreich';
export const GET_NOTIFICATION_TYPES_FEHLER = '[VeranstaltungenModul] GetNotificationTypes Ladefehler';
export const GET_NOTIFICATION_TYPES_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetNotificationTypes nicht ausgeführt (evtl. Offline)';


export class GetNotificationTypesAction implements Action {
    readonly type = GET_NOTIFICATION_TYPES;
        constructor(public optPayload: any = null) {}
    }
export class GetNotificationTypesAusfuehrenAction implements Action {
    readonly type = GET_NOTIFICATION_TYPES_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetNotificationTypesErfolgreichAction implements Action {
    readonly type = GET_NOTIFICATION_TYPES_ERFOLGREICH;
        constructor(public payload: Array<api.NotificationMessageTypeInfo>, public optPayload: any = null) {}
    }
export class GetNotificationTypesFehlerAction implements Action {
    readonly type = GET_NOTIFICATION_TYPES_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetNotificationTypesNichtAusgefuehrtAction implements Action {
    readonly type = GET_NOTIFICATION_TYPES_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryNotificationTypesActions =
    GetNotificationTypesAction
    | GetNotificationTypesAusfuehrenAction
    | GetNotificationTypesErfolgreichAction
    | GetNotificationTypesFehlerAction
    | GetNotificationTypesNichtAusgefuehrtAction
    ;
